import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

// The phone / tablet register — the mobile estate synced from Miradore (MDM).
// Served by the same tech `devices` endpoint (device_type IN phone/tablet), so
// it proxies through /api/devices/phones. staleTime 0 like the device register:
// this is a live inventory, not a cached page.
export function usePhones() {
  return useQuery({
    queryKey: ['phones'],
    queryFn: async () => {
      const { data } = await api.get('/api/devices/phones');
      return data;
    },
    staleTime: 0,
    retry: false,
  });
}

// "Sync now" runs the whole device sync (Atera + Wazuh + Miradore) — the same
// endpoint the laptop register uses — then refreshes both registers.
export function useSyncPhones() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post('/api/devices/sync')).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['phones'] });
      queryClient.invalidateQueries({ queryKey: ['devices'] });
    },
  });
}
